(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return
    observer.unobserve(productRecommendationsSection)
    const url = productRecommendationsSection.dataset.url
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          const newList = recommendations.querySelectorAll('ul li')
          let int = 0
          newList.forEach((listItem) => {
            const listItemTitle = listItem.querySelector('.product__title').innerText
            if (listItemTitle.toLowerCase().includes('custom')) {
              listItem.remove()
            } else {
              if (int <= 3) {
              } else {
                listItem.remove()
              }
              int++
            }
          })
          productRecommendationsSection.innerHTML = recommendations.innerHTML

          // if (typeof yotpo != 'undefined') {

            yotpoWidgetsContainer.initWidgets();

          // }

        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
  const productRecommendationsSection = document.querySelector('.product-recommendations')
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 0px 0px' })
  observer.observe(productRecommendationsSection)

  } catch(e) { console.error(e); }
})();
      })();
